import { req } from "@/api/api_request";

// 获取污染源列表 传{}获取所有
export function getPollutantList({ group_id, search, page, size }) {
  let url = `pollutant/get-list?group_id=${group_id}`;
  if (page) {
    url += `&page=${page}`;
  }
  if (size) {
    url += `&size=${size}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  return req.get(url);
}

// 新建污染源
export function addPollutant(params) {
  let url = `pollutant/add`;
  return req.post(url, params);
}

// 编辑污染源
export function updatePollutant(params) {
  let url = `pollutant/update`;
  return req.post(url, params);
}

// 删除污染源
export function deletePollutant(id) {
  let url = `pollutant/delete?pollutant_id=${id}`;
  return req.post(url);
}

// 获取污染源详情
export function getPollutantDetails(pollutant_id) {
  let url = `pollutant/get-detail?pollutant_id=${pollutant_id}`;
  return req.get(url);
}

// 添加污染源巡查日志
export function addPollutantLog(params) {
  let url = `pollutant/add-log`;
  return req.post(url, params);
}

// 污染源巡查日志列表
export function getPollutantLogList(pollutant_id) {
  let url = `pollutant/get-log-list?pollutant_id=${pollutant_id}`;
  return req.get(url);
}
